@if (modelList(); as models) {
    <div class="flex flex-col gap-8 lg:gap-24">
        <h1 class="text-center text-24 leading-28 text-black lg:text-34 lg:leading-41">Unsere Hyundai Modelle</h1>
        <ui-m040-c110-model-select
            [activeCategory]="activeCategory() ?? models.categories[0]"
            [categories]="models.categories"
            [filteredModels]="filteredModels()"
            (categorySelected)="activeCategory.set($event)"
            isFirstView
        />
        <div class="flex justify-center py-12">
            <a
                ui-m010-c020-icon-link
                [trackingElTarget]="dealer().pages.models"
                [hyundaiRouterLink]="dealer().pages.models"
                trackingElType="basic link"
                tracking
                trackingElLabel="All Models"
                isFirstView
            >
                Alle Modelle
            </a>
        </div>
    </div>
}
